import React, { Component } from 'react'
import _ from 'lodash'
import I18n from '../lib/i18n'
import ReactBottomSheet from 'react-bottomsheet'
import BottomSheetSelectList from './BottomSheetSelectList'
import * as StyledComponent from '../styles'
import withRef from '../lib/withRef'
import Analytics from '../lib/analytics'
import { isAlipayHK } from '../helpers/detectBrowser'
import * as API from '../api'

const ApplePaySession = window.ApplePaySession
const AlipayJSBridge = window.AlipayJSBridge

class PaymentOptionsBottomSheet extends Component {
  state = {
    form_url: '',
    form_data: {}
  }

  async componentDidMount() {
    // handle QFPay after redirect from the oauth_url
    const { order_id, payment_provider_id, router_history } = this.props

    if (order_id && payment_provider_id) {
      this.props.toggleCheckoutLoading(true)
      try {
        const fetch_order_res = await API.fetchOrder(this.props.order_id)
        const { total_price } = fetch_order_res.data.order
        const open_id = new URLSearchParams(window.location.search).get('openid')
        const create_payment_request_res = await this.createPaymentRequest({
          order_id: parseInt(order_id),
          payment_provider_id: parseInt(payment_provider_id),
          openid: open_id,
          amount: total_price,
          h5_complete_url: `${window.location.origin}${window.location.search}#/${I18n.currentLocale()}/order_history`,
        })
        const { payment_request } = create_payment_request_res.data
        const { payment_data, provider_payment_type } = payment_request
        const { pay_url, trade_no } = payment_data

        switch(provider_payment_type) {
          case 'WECHAT':
            window.location.href = pay_url
            break
          case 'ALIPAY':
            AlipayJSBridge.call("tradePay", {
               tradeNO: trade_no
            })
            break
          default:
            break
        }
      } catch(err) {
        this.handleError(err)
        router_history.replace()
      }
    }
  }

  handleSelectPayment = async (payment_provider) => {
    const { payment_provider_internal_code } = payment_provider
    const merchant_id = this.props.store.system_settings['payment_gateway.settings.applepay.merchant_id']

    if (payment_provider_internal_code === 'CYBS_APPLEPAY_WEB') {
      this.props.toggleCheckoutLoading(true)
      // Check Apple Pay can make payment
      const ok = await this.checkCanMakePayment(merchant_id)

      if (!ok) {
        const modal_props = {
          title: I18n.t('containers.cart.place_order'),
          body: I18n.t('containers.cart.invalid_card'),
          buttons: [
            {
              onClick: () => this.props.confirm_modal.close(),
              text: I18n.t('containers.cart.dismiss')
            }
          ]
        }

        this.props.setModalProps(modal_props)
        this.props.toggleCheckoutLoading(false)
        this.props.confirm_modal.open()
        return
      }
    }

    this.confirmPlaceOrder(payment_provider)
  }

  confirmPlaceOrder = async (payment_provider) => {
    const { payment_provider_internal_code, id: payment_provider_id } = payment_provider
    const { order } = this.props.store
    let payment_request_req_data = {
      order_id: order.id,
      payment_provider_id: payment_provider.id,
      amount: order.total_price,
    }
    let body = I18n.t('containers.cart.place_order_message')
    let cb = () => {}
    let apple_pay_buttons

    switch (payment_provider_internal_code) {
      case 'CYBS_VM':
        body = [
          <p key='message-1'>{I18n.t('containers.cart.place_order_message')}</p>,
          <p key='message-2'>{I18n.t('containers.cart.payment_redirect_message')}</p>
        ]
        cb = async () => {
          payment_request_req_data.mode = 'SA'
          payment_request_req_data.redirect_url = `${window.location.origin}${window.location.pathname}${window.location.search}#/${I18n.currentLocale()}/order_history`

          try {
            const create_payment_request_res = await this.createPaymentRequest(payment_request_req_data)
            const { payment_request } = create_payment_request_res.data

            this.submitCybersourceForm(payment_request)
          } catch(err) {
            this.handleError(err)
          }
        }
        break
      case 'CYBS_APPLEPAY_WEB':
        payment_request_req_data.mode = 'APPLEPAY_ON_WEB'
        const create_payment_request_res = await this.createPaymentRequest(payment_request_req_data)
        const { payment_request } = create_payment_request_res.data

        apple_pay_buttons = [
          {
            onClick: () => {
              this.props.confirm_modal.close()
              this.doPayment(payment_request)
            },
            text: I18n.t('containers.cart.yes')
          },
          {
            onClick: () => {
              this.props.confirm_modal.close()
            },
            text: I18n.t('containers.cart.no'),
            secondary: true
          }
        ]
        break

      case 'ALIPAY_H5_WAP_MAINLAND_HK':
        cb = async () => {
          try {
            const pay_tag = isAlipayHK() ? 'ALIPAYHK' : 'ALIPAYCN'
            payment_request_req_data.pay_tag = pay_tag
            payment_request_req_data.h5_complete_url = `${window.location.origin}${window.location.pathname}${window.location.search}#/${I18n.currentLocale()}/order_history/`
            const create_payment_request_res = await this.createPaymentRequest(payment_request_req_data)
            const pay_url = _.get(create_payment_request_res, 'data.payment_request.payment_data.pay_url')

            if (_.isEmpty(pay_url)) {
              throw 'redirect url not exist'
              return
            }

            API.saveCompletedOrderToStorage(order.id)

            window.location.href = pay_url
          } catch(err) {
            this.handleError(err)
          }
        }
        break
      case 'WECHAT_H5_MAINLAND_HK':
      case 'ALIPAY_H5_MAINLAND':
        cb = async () => {
          const redirectURL = encodeURIComponent(`${window.location.href}?order_id=${order.id}&payment_provider_id=${payment_provider_id}`)
          // show loading while getting oauth_url
          this.props.toggleCheckoutLoading(true)
          try {
            const oauth_res = await API.getOpenId(payment_provider_id, redirectURL)
            const oauth_url = oauth_res.data.qfpay_overseas_oauths.oauth_url

            // save the order slug as completed before redirecting to qfpay auth url
            API.saveCompletedOrderToStorage(order.id)
            window.location.href = oauth_url
          } catch(err) {
            this.handleError(err)
          }
        }
        break
      case 'deferred':
        body = [
          <p key='message-1'>{I18n.t('containers.cart.place_order_message')}</p>,
          <p key='message-2'>{I18n.t('containers.cart.pay_at_cashier_message')}</p>
        ]
        cb = async () => {
          try {
            this.props.toggleCheckoutLoading(true)
            await API.markOrderAsDeferPayment(order.id)
            API.saveCompletedOrderToStorage(order.id)
            this.props.router_history.push(`/${I18n.currentLocale()}/order_history`)
          } catch(err) {
            this.handleError(err)
          } finally {
            this.props.toggleCheckoutLoading(false)
            this.props.togglePaymentOptionsList(false)
          }
        }
        break
      default:
        break
    }

    const title = I18n.t('containers.cart.place_order')
    const buttons = apple_pay_buttons
      ? apple_pay_buttons
      : [
          {
            onClick: () => this.handlePlaceOrder(cb),
            text: I18n.t('containers.cart.yes')
          },
          {
            onClick: () => {
              this.props.confirm_modal.close()
            },
            text: I18n.t('containers.cart.no'),
            secondary: true
          }
        ]
    const modal_props = {
      title,
      body,
      buttons
    }

    this.props.setModalProps(modal_props)
    this.props.confirm_modal.open()
  }

  handlePlaceOrder = (cb) => {
    this.props.confirm_modal.close()
    cb()
  }

  createPaymentRequest = async (data) => {
    try {
      this.props.toggleCheckoutLoading(true)
      const res = await API.createPaymentRequest(data)

      Analytics.execute({
        plugin_name: 'ec',
        action: 'setAction',
        action_type: 'purchase',
        payload: {
        }
      })

      Analytics.event({ category: 'Minicart - Cart', action: 'Place Order' })

      return Promise.resolve(res)
    } catch(err) {
      this.setState({ inline_error_msg: {} })
      this.handleError(err)

      return Promise.reject({})
    } finally {
      this.props.toggleCheckoutLoading(false)
      this.props.togglePaymentOptionsList(false)
    }
  }

  submitCybersourceForm = async (payment_request) => {
    const { order } = this.props.store
    const { payment_data = {} } = payment_request
    const { pay_url, pay_params } = payment_data
    const form = document.getElementById('payment-form')

    this.props.toggleCheckoutLoading(true)
    // save the order slug as completed before submitting cybersource form
    API.saveCompletedOrderToStorage(order.id)
    this.setState({ form_url: pay_url, form_data: pay_params }, () => form.submit())
  }

  checkCanMakePayment = (merchant_id) => {
    if (ApplePaySession) {
      return ApplePaySession.canMakePaymentsWithActiveCard(merchant_id)
    }
  }

  doPayment = async (payment_request) => {
    const { order } = this.props.store
    const { payment_data = {}, id: payment_request_id } = payment_request
    const applepay_request = _.get(payment_data, 'applepay_request', {})
    const version = 3
    const session = new ApplePaySession(version, applepay_request)

    this.props.toggleCheckoutLoading(true)

    session.onvalidatemerchant = async (event) => {
      const apple_pay_merchant_data = {
        validation_url: event.validationURL,
        frontend_domain: window.location.hostname
      }
      try {
        const validate_merchant_res = await API.validateMerchant(payment_request_id, apple_pay_merchant_data)
        const { session: res_session } = validate_merchant_res.data.apple_pay_merchant

        session.completeMerchantValidation(res_session)
      } catch(err) {
        this.handleError(err)

        this.props.toggleCheckoutLoading(false)
        try { session.abort() } catch(err) {}
      }
    }
    session.oncancel = (event) => {
      this.props.toggleCheckoutLoading(false)
    }
    session.onpaymentauthorized = async (event) => {
      const tokenStr = btoa(JSON.stringify(event.payment.token.paymentData))

      try {
        const authorization = await API.authorizeApplePay({
          payment_request_id,
          payload_params: { token: tokenStr },
        })

        if (authorization.status === "success") {
          try {
            session.completePayment(ApplePaySession.STATUS_SUCCESS)
          }
          catch(err) {
            console.log(err)
          } finally {
            // save the order slug as completed when payment is authorized
            API.saveCompletedOrderToStorage(order.id)
            this.props.router_history.push(`/${I18n.currentLocale()}/order_history`)
          }
        }
      } catch(err) {
        this.handleError(err)

        try {
          session.completePayment(ApplePaySession.STATUS_FAILURE)
        } catch(err) {
         console.log(err)
        } finally {
          this.props.toggleCheckoutLoading(false)
        }
      }
    }
    session.begin()
  }

  handleError = (err) => {
    const error = API.handleError(err)

    this.saveToStore({ alert_message: error.error_message }, () => this.props.store.flash.open())
  }

  setInlineErrorMsg = (sku_id, err_msg) => {
    this.setState({
      inline_error_msg: {
        ...this.state.inline_error_msg,
        [sku_id]: err_msg
      }
    })
  }

  saveToStore = (state, cb) => {
    this.props.store.save(state, cb)
  }

  render() {
    const {
      store,
      open,
      onClose
    } = this.props
    const { available_payment_providers = [] } = store

    // props for bottom sheet
    const bottom_sheet_props = {
      visible: open,
      appendCancelBtn: false,
      list: [],
      onClose: onClose
    }
    const payment_options_list = _.map(available_payment_providers, (payment_provider) => {
      const { payment_provider_internal_code } = payment_provider

      if (payment_provider_internal_code === 'ALIPAY_H5_MAINLAND' ||
        payment_provider_internal_code === 'WECHAT_H5_MAINLAND_HK' ||
        payment_provider_internal_code === 'ALIPAY_H5_WAP_MAINLAND_HK'
      ) return
      if (payment_provider_internal_code === 'CYBS_APPLEPAY_WEB' && !window.ApplePaySession) return

      return <StyledComponent.PaymentProvider
        key={payment_provider_internal_code}
        onClick={this.handleSelectPayment.bind(this, payment_provider)}
        className='item-container'
      >
        <img alt={payment_provider_internal_code} src={payment_provider.icon_data_uri} />
        <div className='right-container'>
          <div className='provider-name'>{payment_provider.name}</div>
          {
            payment_provider_internal_code === 'deferred' &&
              <div className='footnote'>{I18n.t('containers.cart.other_footnote')}</div>
          }
        </div>
      </StyledComponent.PaymentProvider>
    })

    return <StyledComponent.BottomSheet>
      <ReactBottomSheet {...bottom_sheet_props}>
        <BottomSheetSelectList
          title={I18n.t('payment_options_bottom_sheet.select_payment')}
          list={payment_options_list}
          onClose={this.props.onClose}
        />
      </ReactBottomSheet>
      <form id='payment-form' method='post' action={this.state.form_url}>
        {
          _.map(this.state.form_data, (value, key) => {
            return <input key={key} type='hidden' name={key} value={value} />
          })
        }
      </form>
    </StyledComponent.BottomSheet>
  }
}

PaymentOptionsBottomSheet.defaultProps = {
  open: false,
  onClose: () => {}
}

export default withRef(PaymentOptionsBottomSheet)



// WEBPACK FOOTER //
// ./src/components/PaymentOptionsBottomSheet.js